export default "__VITE_ASSET__82bbac7d__"